// The order the builder lists fields in and the embed renders them, shared so the
// live preview can't drift from the form it is previewing.
export const FIELD_ORDER = ["first_name", "last_name", "email", "phone"];

export const FIELD_TITLES = {
  first_name: "First name",
  last_name: "Last name",
  email: "Email",
  phone: "Phone",
};

export const FIELD_INPUT_TYPES = { email: "email", phone: "tel" };

export const CHANNEL_OPTIONS = [
  { key: "email", label: "Email me updates", checked: true },
  { key: "sms", label: "Text me updates", checked: false },
];

export const AGREEMENT_CHANNELS = ["email", "sms"];

export const agreementChannel = (consent) => {
  if (!consent) return null;
  const channel = String(consent.channel || "");
  if (AGREEMENT_CHANNELS.includes(channel)) return channel;
  const legacy = consent.sms_default;
  return legacy === true || legacy === "true" || legacy === 1 ? "sms" : null;
};

export const channelsWithAgreement = (consents) =>
  new Set(
    (Array.isArray(consents) ? consents : [])
      .filter((c) => c && (c.text || "").trim())
      .map(agreementChannel)
      .filter(Boolean)
  );

export const QUESTION_TYPES = [
  { value: "short_text", label: "Short text" },
  { value: "long_text", label: "Long text" },
  { value: "number", label: "Number" },
  { value: "date", label: "Date" },
  { value: "select", label: "Dropdown" },
  { value: "checkboxes", label: "Checkboxes" },
];

export const CHOICE_QUESTION_TYPES = ["select", "checkboxes"];

export const PLACEHOLDER_QUESTION_TYPES = ["short_text", "long_text", "number"];

export const MAX_QUESTIONS = 20;

const QUESTION_KEY_FORMAT = /^q_[0-9a-f]{6}$/;

export const isRenderableQuestion = (q) => !!q && QUESTION_KEY_FORMAT.test(String(q.key || "")) && !!q.label;

const randomBytes = (count) => {
  const bytes = new Uint8Array(count);
  if (globalThis.crypto?.getRandomValues) return globalThis.crypto.getRandomValues(bytes);
  return bytes.map(() => Math.floor(Math.random() * 256));
};

export const newQuestionKey = () =>
  `q_${Array.from(randomBytes(3)).map((b) => b.toString(16).padStart(2, "0")).join("")}`;
